import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calendar-nav" }

import { reactive } from "vue";
import { DxButton } from 'devextreme-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthSelector',
  emits: ["monthSelected"],
  setup(__props, { emit: __emit }) {

const state = reactive({
  date: { year: (new Date).getFullYear(), month: (new Date).getMonth() },
});

const emit = __emit

async function monthChanged() {
  emit("monthSelected", state.date);
}

function prevMonthClicked(e: any) { 
  if (state.date.month == 0) {
    state.date.month = 11;
    state.date.year--;
  } 
  else {
    state.date.month--;
  }
  monthChanged()
}

function nextMonthClicked(e: any) {
  if (state.date.month == 11) {
    state.date.month = 0;
    state.date.year++;
  } 
  else {
    state.date.month++;
  }
  monthChanged()
}


return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DxButton), {
      hint: "Previos month",
      icon: "chevronleft",
      "styling-mode": "contained",
      type: "normal",
      onClick: prevMonthClicked
    }),
    _createVNode(_component_VueDatePicker, {
      teleport: true,
      modelValue: state.date,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((state.date) = $event)),
        monthChanged
      ],
      "month-picker": "",
      clearable: false
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(DxButton), {
      class: "pad-after-date-picker",
      hint: "Next month",
      icon: "chevronright",
      "styling-mode": "contained",
      type: "normal",
      onClick: nextMonthClicked
    })
  ]))
}
}

})